var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.537,
    height: 17.105,
    viewBox: "0 0 16.537 17.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigExclamationIcon",
    transform: "translate(-1015.484 -374.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16205",
    "data-name": "Group 16205"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_660",
    "data-name": "Ellipse 660",
    cx: 7.769,
    cy: 8.052,
    rx: 7.769,
    ry: 8.052,
    transform: "translate(1015.984 374.999)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942",
    transform: "translate(1022.861 377.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11139",
    "data-name": "Path 11139",
    d: "M-243.8,64.736a.9.9,0,0,1,.89-.97.886.886,0,0,1,.891.97.894.894,0,0,1-.891.97A.9.9,0,0,1-243.8,64.736Zm.377-2.237-.211-7.509h1.449L-242.4,62.5Z",
    transform: "translate(243.799 -54.99)",
    fill: "var(--mainColor)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigExclamationIcon);
export default __webpack_public_path__ + "static/media/bigExclamationIcon.cdc97109332e9607462fa3ed62368e2b.svg";
export { ForwardRef as ReactComponent };